import HTTPUrlHelper from "shared/helpers/HTTPUrlHelper";
import { actionCoreApi } from "core/utils/api";
import ActionsList from "core/actions/Actions.list";
import { ActionType } from "core/utils/interfaces";
import { getValueFromState } from '../../shared/helpers/utils'

const safeRedirect = (url: string | null): string => {
  if (!url) return '/'
  try {
    const parsed = new URL(url)
    if (parsed.protocol === 'https:') return parsed.href
  } catch {
    try {
      const parsed = new URL(url, window.location.origin)
      if (parsed.origin === window.location.origin &&
          (parsed.protocol === 'http:' || parsed.protocol === 'https:')) {
        return parsed.pathname + parsed.search + parsed.hash
      }
    } catch {
      // ignore invalid URL
    }
  }
  return '/'
}

export const verify  = (userName: string, state: string, locale: string,  key: string) : void => {
  fetch(HTTPUrlHelper.verifyUserNameAPI(encodeURIComponent(userName), state, locale, key), {
    method: 'get'
}).then(response => {
             const contentType = response.headers.get("content-type");
             if (contentType && contentType.indexOf("application/json") !== -1) {
               return response.json().then(data => {
                 window.location.href = data
               });
             } else {
               const stateDecoded = atob(state)
               window.location.href = safeRedirect(getValueFromState("returnPath=", stateDecoded))
             }
           });
}

export const fetchCustomLoginSettings = (): ActionType =>
actionCoreApi(
  ActionsList.UserNameExists,
  HTTPUrlHelper.fetchCustomLoginSettings(),
  'GET'
)
